import { LitElement, html } from "lit-element";
import { store } from "../inspx-store.js";
import { login } from "../actions/app.js";
import "@material/mwc-button";
import "../elements/text-box.js";
import { logo } from "../styles/icons.js";
import { CardStyles } from "../styles/card-styles.js";
import { SharedStyles } from "../styles/shared-styles.js";

class InspxLoginBox extends LitElement {
	render() {
		return html`
			${SharedStyles}
            ${CardStyles}
            <style>
                :host {
                    display: none;
                    position: fixed;
                    background-color: #4e4e58b8;
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    right: 0px;
                }
            
                :host([open="true"]) {
                    display: block !important;
                }
            
                .box {
                    background-color: var(--primary-color-variant1);
                    width: 400px;
                    height: 316px;
                    position: fixed;
                    left: calc( 50vw - 200px);
                    top: calc( 50vh - 150px);
                }
            
                .button-box {
                    text-align: center;
                }
            
                .button-box mwc-button {
                    --mdc-theme-primary: var(--secondary-color);
                    width: 100%
                }
            
                .title {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    font-size: x-large;
                    color: var(--secondary-color);
                  
                }

                .title svg {
                    width: 35px;
                    height:35px;
                    fill: var(--secondary-color);
                }

				.error-message {
					margin: 0;
    				color: red;
				}

                @media only screen and (max-width: 460px) {
                    .box {
                        width: 316px;
                        min-height: 316px;
                        position: fixed;
                        left: calc(50vw - 158px);
                        top: calc(50vh - 160px);
                    }
                }
            </style>
            
            <form class="box card" onsubmit="return false;">
                <div class="title"><div>Welcome to InspX</div> <div>${logo}</div></div>
                <text-box name="login" label="login" id="login" required></text-box>
				<text-box name="password" label="password" type="password" id="password" required></text-box>
				<p class="error-message" ?hidden="${!this.error}">${this.error}</p>
                <div class="button-box">
                    <mwc-button id="btn" type="submit" @click="${(e) =>this.login(e)}" label="LOGIN"></mwc-button>
                </div>
            </form>`;
	}

	static get properties() {
		return {
			open: Boolean,
			error: String
		};
	}

	constructor() {
		super();
		this.addEventListener("keydown", this._keyDown.bind(this));
	}

	_keyDown(e) {
		// enter pressed
		if (e.keyCode === 13) {
			this.login(e);
		}
	}

	login(e) {
		e.preventDefault();

		this.shadowRoot.getElementById("btn").focus();
		const lgn = this.shadowRoot.getElementById("login").value;
		const pwd = this.shadowRoot.getElementById("password").value;
		if (lgn && pwd) {
			store.dispatch(login(lgn, pwd));
		}
	}
}

window.customElements.define("inspx-login-box", InspxLoginBox);
